var InFlight = InFlight || {};

InFlight.handlebars = (function() {
  function registerHerlpers() {
    Handlebars.registerHelper('percent', function(lvalue, rvalue) {
      lvalue = parseFloat(lvalue);
      rvalue = parseFloat(rvalue);

      return (100 * lvalue) / rvalue;
    });

    Handlebars.registerHelper('formatDate', function (date, format) {
      var date = Date.parse(date);
      return date.toString(format);
    });    

    Handlebars.registerHelper('i18n', function(term) {
      if (!term) {
        return term;
      }
      return $.i18n(term);
    });

    Handlebars.registerHelper('eq', function(a, b, opts) {
      if (a === b) {
        return opts.fn(this);
      }
    });
    Handlebars.registerHelper('gt', function(a, b, opts) {
      if (a > b) {
        return opts.fn(this);
      }
    });
    Handlebars.registerHelper('gte', function(a, b, opts) {
      if (a >= b) {
        return opts.fn(this);
      }
    });
    Handlebars.registerHelper('lt', function(a, b, opts) {
      if (a < b) {
        return opts.fn(this);
      }
    });
    Handlebars.registerHelper('lte', function(a, b, opts) {
      if (a <= b) {
        return opts.fn(this);
      }
    });
    Handlebars.registerHelper('ne', function(a, b, opts) {
      if (a !== b) {
        return opts.fn(this);
      }
    });
    Handlebars.registerHelper('and', function(a, b, opts) {
      return Array.prototype.slice.call(arguments).every(Boolean);  
    });

    Handlebars.registerHelper('or', function(a, b, opts) {
      return Array.prototype.slice.call(arguments, 0, -1).some(Boolean);      
    });
  }
  return {
    registerHerlpers: registerHerlpers
  };
})();
